import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'field-error',
    templateUrl: './field-error.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldErrorComponent implements OnChanges {

  @Input() message: any;
  @Input() isError = false;

  errorMessage: string | null = null;

  constructor() { }

  ngOnChanges(): void {
    this.errorMessage = this.isError ? this.message : null;
  }

}
